import axios, { AxiosResponse } from "axios";
import { ApiResponse, Content, RequestInputs } from "src/types";

interface AwsFileUploadParams {
  file: File;
  presignedUploadRequestUrl: string;
}

export default class AwsFileUpload {
  private readonly _file: File;

  private readonly presignedUploadRequestUrl: string;

  constructor({ file, presignedUploadRequestUrl }: AwsFileUploadParams) {
    this._file = file;
    this.presignedUploadRequestUrl = presignedUploadRequestUrl;
  }

  async sendPresignedUploadRequest<R, T = void>(
    data?: T,
  ): Promise<AxiosResponse<ApiResponse<R>>> {
    return axios.post(this.presignedUploadRequestUrl, data);
  }

  private getFormDataToUploadS3(file: File, requestInputs: RequestInputs) {
    const formData = new FormData();

    formData.set("key", requestInputs.key);
    formData.set("acl", requestInputs.acl);
    formData.set("X-Amz-Credential", requestInputs["X-Amz-Credential"]);
    formData.set("X-Amz-Algorithm", requestInputs["X-Amz-Algorithm"]);
    formData.set("X-Amz-Date", requestInputs["X-Amz-Date"]);
    formData.set("Policy", requestInputs.Policy);
    formData.set("X-Amz-Signature", requestInputs["X-Amz-Signature"]);
    formData.set("success_action_status", requestInputs.success_action_status);
    formData.set("Content-Type", file.type);
    formData.set("file", file);

    return formData;
  }

  private async sendRequestToS3(
    file: File,
    action: string,
    requestInputs: RequestInputs,
  ): Promise<AxiosResponse<any>> {
    return axios.post(action, this.getFormDataToUploadS3(file, requestInputs));
  }

  async sendAttachmentsToS3(presignedRequestsContent: Content) {
    const { action } = presignedRequestsContent.token.requestAttributes;
    const { requestInputs } = presignedRequestsContent.token;

    await this.sendRequestToS3(this._file, action, requestInputs);
  }
}
